if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (!window.location.pathname.includes('cart')) {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }
      if(this.querySelector('[type="submit"]')) {
        this.submitButton = this.querySelector('[type="submit"]');
      } else if(this.querySelector('[name="add"]')?.id.includes("submit")) {
        this.submitButton = this.querySelector('[name="add"]');
      }
      this.quantitySelector = this.querySelector('cart-quantity');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      var bundleProduct = false;

      if (typeof bundleTemplate !== "undefined" && bundleTemplate.isBundleTemplate) {
        if(bundleVariantOne) {
          bundleProduct = true;
        }
      }
      var bundleVariantIds = [...document.querySelectorAll('.bundle-item-components')];
      var bundleProductInCart = [];
      var len = bundleVariantIds.length;
      for (var i = 0; i < len; i++) {
        bundleProductInCart.push({
          bundleVarId: bundleVariantIds[i].attributes.bundleVarId.value,
          bundleVariantTitle: bundleVariantIds[i].innerText,
        });
      }

      var result1 = [...bundleProductInCart.reduce( (mp, o) => {
        if (!mp.has(o.bundleVarId)) mp.set(o.bundleVarId, { ...o, count: 0 });
        mp.get(o.bundleVarId).count++;
        return mp;
      }, new Map).values()];

      cartGetBundleComponents();
      var errorsFound = 0;
      var bundleErrorMessage = '';
      var result = [...cartItemComponents.reduce( (mp, o) => {
        if (!mp.has(o.id)) mp.set(o.id, { ...o, count: 0 });
        mp.get(o.id).count++;
        return mp;
      }, new Map).values()];

      if(typeof bundleVariantOneInfo !== 'undefined') {
        var checkIfBundleVarOneInCart = result.find(e => e.id === bundleVariantOneInfo.bundleVariantId);
        var checkIfBundleVarOneInCart2 = result1.find(e => e.bundleVarId == bundleVariantOneInfo.bundleVariantId);
    
        if((checkIfBundleVarOneInCart && checkIfBundleVarOneInCart.count === bundleVariantOneInfo.bundleVariantTotalQuantity) || (checkIfBundleVarOneInCart2 && checkIfBundleVarOneInCart2.count === bundleVariantOneInfo.bundleVariantTotalQuantity)) {
          bundleErrorMessage = `All ${bundleVariantOneInfo.bundleVariantTotalQuantity} ${bundleVariantOneInfo.bundleVariant} are in your cart.`;
          errorsFound = errorsFound + 1;
        } else if((checkIfBundleVarOneInCart && checkIfBundleVarOneInCart.count < bundleVariantOneInfo.bundleVariantTotalQuantity) || (checkIfBundleVarOneInCart2 && checkIfBundleVarOneInCart2.count < bundleVariantOneInfo.bundleVariantTotalQuantity)) {
          errorsFound = errorsFound + 0;
        } else {
          errorsFound = errorsFound + 0;
        }
      }
      if(typeof bundleVariantTwoInfo !== 'undefined' && bundleVariantTwoInfo) {
        var checkIfBundleVarTwoInCart = result.find(e => e.id === bundleVariantTwoInfo.bundleVariantId);
        var checkIfBundleVarTwoInCart2 = result1.find(e => e.bundleVarId == bundleVariantTwoInfo.bundleVariantId);
        
        if((checkIfBundleVarTwoInCart && checkIfBundleVarTwoInCart.count === bundleVariantTwoInfo.bundleVariantTotalQuantity) || (checkIfBundleVarTwoInCart2 && checkIfBundleVarTwoInCart2.count === bundleVariantTwoInfo.bundleVariantTotalQuantity)) {
          bundleErrorMessage = `All ${bundleVariantTwoInfo.bundleVariantTotalQuantity} ${bundleVariantTwoInfo.bundleVariant} are in your cart.`;
          errorsFound = errorsFound + 1;
        } else if((checkIfBundleVarTwoInCart && checkIfBundleVarTwoInCart.count < bundleVariantTwoInfo.bundleVariantTotalQuantity) || (checkIfBundleVarTwoInCart2 && checkIfBundleVarTwoInCart2.count < bundleVariantTwoInfo.bundleVariantTotalQuantity)) {
          errorsFound = errorsFound + 0;
        } else {
          errorsFound = errorsFound + 0;
        }
      }
      if(typeof bundleVariantThreeInfo !== 'undefined' && bundleVariantThreeInfo) {
        var checkIfBundleVarTwoInCart = result.find(e => e.id === bundleVariantThreeInfo.bundleVariantId);
        var checkIfBundleVarTwoInCart2 = result1.find(e => e.bundleVarId == bundleVariantThreeInfo.bundleVariantId);
        
        if((checkIfBundleVarTwoInCart && checkIfBundleVarTwoInCart.count === bundleVariantThreeInfo.bundleVariantTotalQuantity) || (checkIfBundleVarTwoInCart2 && checkIfBundleVarTwoInCart2.count === bundleVariantThreeInfo.bundleVariantTotalQuantity)) {
          bundleErrorMessage = `All ${bundleVariantThreeInfo.bundleVariantTotalQuantity} ${bundleVariantThreeInfo.bundleVariant} are in your cart.`;
          errorsFound = errorsFound + 1;
        } else if((checkIfBundleVarTwoInCart && checkIfBundleVarTwoInCart.count < bundleVariantThreeInfo.bundleVariantTotalQuantity) || (checkIfBundleVarTwoInCart2 && checkIfBundleVarTwoInCart2.count < bundleVariantThreeInfo.bundleVariantTotalQuantity)) {
          errorsFound = errorsFound + 0;
        } else {
          errorsFound = errorsFound + 0;
        }
      }
      if(typeof bundleVariantFourInfo !== 'undefined' && bundleVariantFourInfo) {
        var checkIfBundleVarTwoInCart = result.find(e => e.id === bundleVariantFourInfo.bundleVariantId);
        var checkIfBundleVarTwoInCart2 = result1.find(e => e.bundleVarId == bundleVariantFourInfo.bundleVariantId);
        
        if((checkIfBundleVarTwoInCart && checkIfBundleVarTwoInCart.count === bundleVariantFourInfo.bundleVariantTotalQuantity) || (checkIfBundleVarTwoInCart2 && checkIfBundleVarTwoInCart2.count === bundleVariantFourInfo.bundleVariantTotalQuantity)) {
          bundleErrorMessage = `All ${bundleVariantFourInfo.bundleVariantTotalQuantity} ${bundleVariantFourInfo.bundleVariant} are in your cart.`;
          errorsFound = errorsFound + 1;
        } else if((checkIfBundleVarTwoInCart && checkIfBundleVarTwoInCart.count < bundleVariantFourInfo.bundleVariantTotalQuantity) || (checkIfBundleVarTwoInCart2 && checkIfBundleVarTwoInCart2.count < bundleVariantFourInfo.bundleVariantTotalQuantity)) {
          errorsFound = errorsFound + 0;
        } else {
          errorsFound = errorsFound + 0;
        }
      }

      if(bundleProduct && errorsFound > 0) {
        this.handleBundleErrorMessage(bundleErrorMessage);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        evt.preventDefault();
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        
        this.error = true;
        return;
      } else if(bundleProduct && errorsFound == 0) {
        this.handleErrorMessage();
      } else if (!bundleProduct) {
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }


      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let formData;

      if (typeof bundleTemplate !== "undefined" && bundleTemplate.isBundleTemplate) {
        formData = new FormData();
      } else {
        formData = new FormData(this.form);
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof bundleTemplate !== "undefined" && bundleTemplate.isBundleTemplate) {

          let bundleVariantOneId = bundleVariantOne.variant.id;
          let bundleVariantTwoId = bundleVariantTwo.variant.id;
          let bundleVariantThreeId = bundleVariantThree?.variant.id;
          let bundleVariantFourId = bundleVariantFour?.variant.id;
          let bundleObject = {};
          let items;
          let bundleId = new Date().getTime();
          let bundleParentProduct = `gid://shopify/ProductVariant/${bundleTemplate.bundleParentProduct}`;
          let bundleDiscount = bundleTemplate.bundleDiscount;
          // Hacky method of setting this value to 1. When it is set to a default of 0 the line item property doesn't populate on the add to cart
          if(bundleDiscount === 0) {
            bundleDiscount = 1;
          }

          if (bundleVariantOneId && bundleVariantTwoId && !bundleVariantThreeId) {
            items = [{
                "id": bundleVariantOneId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
              {
                "id": bundleVariantTwoId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
            ]
          } else if (bundleVariantOneId && bundleVariantTwoId && bundleVariantThreeId && !bundleVariantFourId) {
            items = [{
                "id": bundleVariantOneId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
              {
                "id": bundleVariantTwoId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
              {
                "id": bundleVariantThreeId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
            ]
          } else if (bundleVariantOneId && bundleVariantTwoId && bundleVariantThreeId && bundleVariantFourId) {
            items = [{
                "id": bundleVariantOneId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
              {
                "id": bundleVariantTwoId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
              {
                "id": bundleVariantThreeId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
              {
                "id": bundleVariantFourId,
                "quantity": 1,
                "properties": {
                  "_bundleId": bundleId,
                  "_bundleParentProduct": bundleParentProduct,
                  "_bundleDiscount": bundleDiscount
                }
              },
            ]
          }

          function buildFormData(formData, key, data) {
            if (data === Object(data) || Array.isArray(data)) {
              for (const i in data) buildFormData(formData, `${key}[${i}]`, data[i]);
            } else data && formData.append(key, data);
          }

          buildFormData(formData, 'items', items);
        }
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      var bundleProduct = false;

      if (typeof bundleTemplate !== "undefined" && bundleTemplate.isBundleTemplate) {
        if(bundleVariantOne) {
          bundleProduct = true;
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response)
              });
            }, {
              once: true
            });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (window.location.href.indexOf("/cart") <= -1) {
            const scrollbarVisible = (element) => {
              return element.scrollHeight > element.clientHeight;
            }
            const cartDrawerContainer = document.querySelector('cart-drawer-items')
            if (scrollbarVisible(cartDrawerContainer) === true) {
              document.querySelector('.cart-drawer .drawer__cart-items-wrapper').style.marginRight = '1rem';
              document.querySelector('.cart-drawer .cart-alert').style.marginRight = '1rem';
              document.querySelector('.cart-drawer .slider-button--next').style.marginRight = '1rem';
            }

            let cartTotalValue = Number(document.querySelector('.totals__subtotal-value').getAttribute('value'));
            if (gwpProduct.gwpToggle) {
              if (gwpProduct.gwpVariation === 'Auto Add' && gwpProduct.gwpProductInformation.available && cartTotalValue >= gwpProduct.gwpGoal) {
                addAutoAddGiftWithPurchase();
              } else if (gwpProduct.gwpVariation === 'Auto Add' && gwpProduct.gwpProductInformation.available && cartTotalValue < gwpProduct.gwpGoal) {
                removeAutoAddGiftWithPurchase();
              } else if (gwpProduct.gwpVariation === 'User Add' && cartTotalValue >= gwpProduct.gwpGoal) {
                checkIfUserAddGiftProductExistsInCart();
                document.getElementById('userAddGiftWithPurchase').addEventListener('submit', addUserAddGiftWithPurchase);
              } else if (gwpProduct.gwpVariation === 'User Add' && cartTotalValue < gwpProduct.gwpGoal) {
                checkIfUserAddGiftProductExistsInCart();
                removeUserAddGiftWithPurchase();
              }
            }
          }
        });
    }

      handleBundleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}